import { useLocation } from "react-router-dom";
import { Nav } from "../components/Nav";
import { Footer } from "../components/Footer";
import { FloatingWhatsApp } from "../components/FloatingWhatsApp";
import { IMAGES, optimizedImageUrl } from "../data/site";

const PAGE_BANNERS = {
  "/about": {
    eyebrow: "Our Story",
    title: "A Place to Gather, Share & Enjoy",
    description: "Fresh flavours, warm hospitality, and memorable moments.",
    image: IMAGES.about,
    alt: "Warm restaurant ambience at Lucky's Kitchen",
  },
  "/why-us": {
    eyebrow: "The Lucky's Difference",
    title: "Good Food, Made With Care",
    description: "Thoughtful ingredients and heartfelt hospitality in every visit.",
    image: IMAGES.specialities[0].url,
    alt: "A freshly prepared Indian special from Lucky's Kitchen",
  },
  "/gallery": {
    eyebrow: "From Our Kitchen",
    title: "A Taste Worth Seeing",
    description: "A glimpse into the dishes and moments we love to share.",
    image: IMAGES.gallery[2].src,
    alt: "A colourful Indian food spread",
  },
  "/banquet-hall": {
    eyebrow: "Events & Celebrations",
    title: "Celebrate Every Occasion With Us",
    description: "A welcoming setting for celebrations, gatherings and memorable moments at Lucky's Kitchen.",
    image: "/images/luckys-kitchen-banquet-hall-stage-bhubaneswar.jpeg",
    alt: "Lucky's Kitchen banquet hall stage decorated for a celebration",
  },
  "/testimonials": {
    eyebrow: "Guest Stories",
    title: "Shared Around the Table",
    description: "Hear from the guests who make Lucky's Kitchen special.",
    image: IMAGES.gallery[4].src,
    alt: "Guests' favourite dining experience at Lucky's Kitchen",
  },
  "/contact": {
    eyebrow: "Visit Us",
    title: "We'd Love to Welcome You",
    description: "Find your nearest Lucky's Kitchen in Bhubaneswar.",
    image: IMAGES.ambience,
    alt: "Evening ambience at Lucky's Kitchen",
  },
};

export default function PublicPageLayout({ children }) {
  const { pathname } = useLocation();
  const banner = PAGE_BANNERS[pathname];

  return (
    <>
      <Nav />
      <main className={pathname === "/" ? "" : "pt-[6.25rem]"}>
        {banner && (
          <section
            aria-labelledby="page-banner-title"
            className="relative flex min-h-[280px] items-end overflow-hidden bg-brand-ink sm:min-h-[340px] lg:min-h-[390px]"
          >
            <img
              src={optimizedImageUrl(banner.image)}
              alt={banner.alt}
              className="absolute inset-0 h-full w-full object-cover"
              fetchPriority="high"
            />
            <div
              aria-hidden="true"
              className="absolute inset-0 bg-gradient-to-r from-[#140a06]/90 via-[#140a06]/60 to-[#140a06]/20"
            />
            <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-10 pt-14 sm:px-8 sm:pb-14 lg:px-16">
              <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] text-brand-gold sm:text-sm">
                <span aria-hidden="true" className="h-px w-8 bg-brand-gold" />
                {banner.eyebrow}
              </p>
              <h1
                id="page-banner-title"
                className="mt-4 max-w-3xl font-serif text-3xl font-bold leading-tight text-brand-cream sm:text-5xl lg:text-6xl"
              >
                {banner.title}
              </h1>
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-brand-cream/80 sm:text-base">
                {banner.description}
              </p>
            </div>
          </section>
        )}
        {children}
      </main>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
}
